
export interface FBProfilePrivate {
    email: string
    emailVerified: boolean,
    photoURL: string,
    isAnonymous: boolean,
}

export interface UserData extends FBProfilePrivate {
    displayName: string,
    uid: string,
    providerData: any
}

export interface Profile {
    name: string,
    nick: string,
    description: string
}

export interface FBProfilePublic extends Profile {
    uid: string,
}

export interface FBProfile {
    public: FBProfilePublic
    private: FBProfilePrivate
}

export type ProfilePublic = FBProfilePublic

export const validforProfit = ['yes', 'no'] as const;
export type forProfit = typeof validforProfit[number];

export const validState = ['1', '2', '3'] as const;
export type projectState= typeof validState[number];

export interface FBProjectPublic {
    name: string,
    abstract: string,
    description: string,
    pictureURL: string,
    discussionURL: string,
    forProfit: forProfit,
    zip_code: string | null, 
    city: string | null, 
    state: projectState,
}

export type ProjectPublic = FBProjectPublic;

export interface FBProjectInternal {
    creationTimestamp: number,
    modificationTimestamp: number
}

export interface FBProjectLikes {
    [uid: string]: boolean | undefined
}

export interface FBProject {
    public?: FBProjectPublic,
    likes?: FBProjectLikes,
    internal: FBProjectInternal
}

export interface ProjectPath {
    uid: string,
    pid: ValidPidValues,
}

export interface Project extends FBProjectPublic, FBProjectInternal, ProjectPath {
    like: boolean,
    likeCount: number
}


// https://stackoverflow.com/questions/44497388/typescript-array-to-string-literal-type
// https://www.typescriptlang.org/docs/handbook/advanced-types.html#string-literal-types
// https://www.typescriptlang.org/docs/handbook/advanced-types.html#index-types

export const validPidValues = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98',
    '99'] as const;
export type ValidPidValues = typeof validPidValues[number];

// export function isValidPidValues(input : any) : input is ValidPidValues {
//     return validPidValues.includes(input);
// }

// https://www.typescriptlang.org/docs/handbook/advanced-types.html#type-guards-and-differentiating-types
export function isValidPidValue(pid: any): pid is ValidPidValues {
    return validPidValues.includes(pid);
    /*
    if (pid != null && typeof pid === 'string') {
        if (pid.length !== 2)
            return false;
        const id = parseInt(pid);
        if (isNaN(id)) return false;
        return !!(0 <= id && id < 100);
    }
    return false;
     */
}

export interface FBProjectStore {
    [uid: string]: {
        [pid in ValidPidValues]?: FBProject
    } | null;
}

export interface ProjectsStore {
    [uid: string]: {
        [pid in ValidPidValues]?: Project
    } | null,
}

export interface Projects {
    store: ProjectsStore,
    projectPathList: ProjectPath[]
}


